import { useQuery } from '@tanstack/react-query'

import { countriesServices } from '../countriesServices'

import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetCountriesCatalog = () =>
  useQuery({
    queryKey: [QUERY_KEYS.CATALOGS_COUNTRIES],
    queryFn: countriesServices.getCountries,
    staleTime: 60 * 60 * 1000, // 1 hour
  })
